import request from "@/utils/request"


// 获取打印历史记录(不含补打)
export const getRecord = function(query) {
  return request('get', '/api/print/list', query)
}

// 获取打印历史记录(含补打)
export const getAllRecord = function(query) {
  return request('get', '/api/print/mobile/list', query)
}

// 获取标签打印总数/补打总数
export const getPrintCount = function(query) {
  return request('get', '/api/statistics/tagPrintCount', query)
}

// 获取打印详情
export const getPrintDetail = function(id) {
  return request('get', `/api/print/detail/${id}`)
}

// 获取补打详情
export const getAllPrintDetail = function(id) {
  return request('get', `/api/print/mobile/detail/${id}`)
}

// 标签打印/补打
export const tagPrint = function(params) {
  return request('post', '/api/print/save', params)
}